import { render, staticRenderFns } from "./book.vue?vue&type=template&id=93c1ce4c"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"
import style0 from "./book.vue?vue&type=style&index=0&id=93c1ce4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports